/**
 * @generated SignedSource<<1e42757e83f95b097e980840a51cb537>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaperPageQuery$variables = {
  id: string;
};
export type PaperPageQuery$data = {
  readonly paperByExternalId: {
    readonly abstract: string;
    readonly arxivId: string | null | undefined;
    readonly title: string;
    readonly venue: string | null | undefined;
    readonly versions: ReadonlyArray<{
      readonly abstract: string;
      readonly number: number;
      readonly title: string;
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"PaperDetailFragment" | "RelatedPapersFragment">;
  } | null | undefined;
};
export type PaperPageQuery = {
  response: PaperPageQuery$data;
  variables: PaperPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "arxivId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "venue",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "abstract",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "authors",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "comment",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "absUrl",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pdfUrl",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "htmlUrl",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "openalexId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primaryCategory",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "announcedOn",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "citedByCount",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bookmarkCount",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerBookmarked",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PaperPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Paper",
        "kind": "LinkedField",
        "name": "paperByExternalId",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PaperVersion",
            "kind": "LinkedField",
            "name": "versions",
            "plural": true,
            "selections": [
              (v6/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PaperDetailFragment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RelatedPapersFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "PaperPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Paper",
        "kind": "LinkedField",
        "name": "paperByExternalId",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PaperVersion",
            "kind": "LinkedField",
            "name": "versions",
            "plural": true,
            "selections": [
              (v6/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v7/*:: as any*/),
              (v8/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "submittedAt",
                "storageKey": null
              },
              (v9/*:: as any*/),
              (v10/*:: as any*/),
              (v11/*:: as any*/)
            ],
            "storageKey": null
          },
          (v12/*:: as any*/),
          (v13/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          (v7/*:: as any*/),
          (v14/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "categories",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "publishedAt",
            "storageKey": null
          },
          (v15/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "doi",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "journalRef",
            "storageKey": null
          },
          (v8/*:: as any*/),
          (v16/*:: as any*/),
          (v9/*:: as any*/),
          (v10/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pdfLicense",
            "storageKey": null
          },
          (v11/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "landingUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "linkedAuthors",
            "plural": true,
            "selections": [
              (v12/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "username",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "orcid",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "imageThumbnail",
                    "storageKey": null
                  }
                ],
                "type": "Entity",
                "abstractKey": "__isEntity"
              }
            ],
            "storageKey": null
          },
          (v17/*:: as any*/),
          (v18/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assessmentRequestable",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PaperAssessment",
            "kind": "LinkedField",
            "name": "assessment",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "summary",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "aiLikelihood",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "aiUseDisclosed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "aiDisclosureQuote",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fullText",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "model",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "arxivVersion",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PaperFlag",
                "kind": "LinkedField",
                "name": "flags",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "kind",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "detail",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 6
              }
            ],
            "concreteType": "Paper",
            "kind": "LinkedField",
            "name": "relatedPapers",
            "plural": true,
            "selections": [
              (v12/*:: as any*/),
              (v2/*:: as any*/),
              (v13/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v7/*:: as any*/),
              (v14/*:: as any*/),
              (v3/*:: as any*/),
              (v16/*:: as any*/),
              (v15/*:: as any*/),
              (v17/*:: as any*/),
              (v18/*:: as any*/)
            ],
            "storageKey": "relatedPapers(limit:6)"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d32a121475bcbf6213a12fd3531412c9",
    "id": null,
    "metadata": {},
    "name": "PaperPageQuery",
    "operationKind": "query",
    "text": "query PaperPageQuery(\n  $id: String!\n) {\n  paperByExternalId(id: $id) {\n    arxivId\n    venue\n    title\n    abstract\n    versions {\n      number\n      title\n      abstract\n    }\n    ...PaperDetailFragment\n    ...RelatedPapersFragment\n    id\n  }\n}\n\nfragment EntityProfilePicFragment_49kWkb on Entity {\n  __isEntity: __typename\n  displayName\n  imageThumbnail\n}\n\nfragment PaperAssessmentFragment on Paper {\n  id\n  version\n  assessmentRequestable\n  assessment {\n    status\n    summary\n    aiLikelihood\n    aiUseDisclosed\n    aiDisclosureQuote\n    fullText\n    model\n    arxivVersion\n    flags {\n      kind\n      detail\n    }\n  }\n}\n\nfragment PaperBookmarkButtonFragment on Paper {\n  id\n  bookmarkCount\n  viewerBookmarked\n}\n\nfragment PaperCardFragment on Paper {\n  arxivId\n  openalexId\n  title\n  abstract\n  authors\n  primaryCategory\n  venue\n  citedByCount\n  announcedOn\n  ...PaperBookmarkButtonFragment\n}\n\nfragment PaperDetailFragment on Paper {\n  id\n  arxivId\n  openalexId\n  version\n  title\n  abstract\n  authors\n  primaryCategory\n  categories\n  publishedAt\n  announcedOn\n  updatedAt\n  doi\n  journalRef\n  comment\n  venue\n  citedByCount\n  absUrl\n  pdfUrl\n  pdfLicense\n  htmlUrl\n  landingUrl\n  linkedAuthors {\n    id\n    username\n    displayName\n    orcid\n    ...EntityProfilePicFragment_49kWkb\n  }\n  versions {\n    number\n    title\n    abstract\n    authors\n    comment\n    submittedAt\n    absUrl\n    pdfUrl\n    htmlUrl\n  }\n  ...PaperBookmarkButtonFragment\n  ...PaperAssessmentFragment\n}\n\nfragment RelatedPapersFragment on Paper {\n  relatedPapers(limit: 6) {\n    id\n    ...PaperCardFragment\n  }\n}\n"
  }
};
})();

(node as any).hash = "d65b3797004471eac0201ef0b9470197";

export default node;
